import { ChangeEvent, InputHTMLAttributes, useEffect, useState } from "react";
import Input from "@weave-design/input";

export const DebouncedInput = ({
    value: initialValue,
    onChange,
    debounceTime = 500,
    ...props
}: {
    value: string;
    onChange: (value: string) => void;
    debounceTime?: number;
} & Omit<InputHTMLAttributes<HTMLInputElement>, "onChange">) => {
    const [value, setValue] = useState(initialValue);

    useEffect(() => {
        setValue(initialValue);
    }, [initialValue]);

    useEffect(() => {
        const timeout = setTimeout(() => {
            onChange(value);
        }, debounceTime);

        return () => clearTimeout(timeout);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value]);

    return (
        <Input
            {...props}
            value={value}
            onChange={(event: ChangeEvent<HTMLInputElement>) => setValue(event.target.value)}
        />
    );
};
